import { observer } from "mobx-react-lite";
import React from "react";
import { Col, Form } from "react-bootstrap";
import FuelTypeSelectViewModel from "viewModels/common/fuelTypeSelectViewModel";
import { registerView, View, ViewComponent } from "@frui.ts/views";
import FuelViewModel from "viewModels/eshop/order/components/fuelViewModel";
import LoaderOverlay from "@edaz/edazkit/LoaderOverlay";
import LoadingPane from "controls/loadingPane";

const FuelTypeSelect: ViewComponent<FuelTypeSelectViewModel> = observer(({ vm }) => {
  const ta = (code: string) => {
    return vm.localizationService.translateAttribute("orderItem", code);
  };
  const fuelScreenReaderLabel = (fuelViewModel: FuelViewModel) => `${fuelTypeLabel}: ${fuelViewModel.fuelTypeItem.name}`;
  const fuelTypeLabel = ta("fuelType");

  // If multiEshop, we need to distinguish batch indexes to prevent displaying items with the same ID.
  if (vm.batchIndex) {
    vm.fuelTypeViewModels.forEach(x => {
      x.batchIndex = vm.batchIndex;
    });
  }

  return (
    <fieldset className="form-row mb-4">
      <Form.Group as={Col} xs={12} className="m-0">
        <LoaderOverlay loading={!vm.isInitialized} loader={<LoadingPane />}>
          <Form.Row className={"align-items-center" + (vm.fuelTypeError !== undefined ? " is-invalid" : "")}>
            {vm.fuelTypeViewModels.map(fuelViewModel => (
              <Form.Group
                controlId={fuelViewModel.fuelTypeItem.fuelType}
                as={Col}
                key={fuelViewModel.fuelTypeItem.id}
                sm={12}
                xl={6}
                className="mb-0 pl-2 pr-2">
                <Form.Label className="screenreader">{fuelScreenReaderLabel(fuelViewModel)}</Form.Label>
                <View vm={fuelViewModel} />
              </Form.Group>
            ))}
          </Form.Row>
          {vm.fuelTypeError && (
            <Form.Control.Feedback type="invalid">
              {vm.localizationService.translateAttribute("orderItem", "fuelTypeId.required")}
            </Form.Control.Feedback>
          )}
        </LoaderOverlay>
      </Form.Group>
    </fieldset>
  );
});

registerView(FuelTypeSelect, FuelTypeSelectViewModel);
